import instObj from '@/backend/axios-instances'

const resource = "/drawinghighlights/image"
const instance = instObj.baseInstance

export default {
  post(id, data) {
    return instance.post(`${resource}/${id}`, data);
  },
  delete(id) {
    return instance.delete(`${resource}/${id}`);
  }
}
